import { useEffect, useState } from 'react';
import { Banner, Button, Input, Spin, Table, Typography } from '@douyinfe/semi-ui';
import { IconRefresh, IconSearch } from '@douyinfe/semi-icons';
import { api, AdminAPIError } from './api';
import { integrationError } from './appBossIntegration';
import type { AuditLog } from './types';

export function AppBossAudit({ onDenied }: { onDenied: (error: unknown) => void }) {
  const [actor, setActor] = useState(''), [action, setAction] = useState('');
  const [query, setQuery] = useState({ actor: '', action: '' }), [reload, setReload] = useState(0);
  const [records, setRecords] = useState<AuditLog[]>([]), [loading, setLoading] = useState(true), [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController(); setLoading(true); setRecords([]); setError('');
    void api.appBossAudits(query, controller.signal).then((rows) => { if (!controller.signal.aborted) setRecords(rows); })
      .catch((error) => { if (!controller.signal.aborted) { setError(integrationError(error)); if (error instanceof AdminAPIError && [401, 403].includes(error.status)) onDenied(error); } })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [query, reload, onDenied]);
  return <div className="integration-form">
    <form className="integration-actions" onSubmit={(event) => { event.preventDefault(); setQuery({ actor: actor.trim(), action: action.trim() }); }}>
      <Input aria-label="连接变更操作者" placeholder="操作者" value={actor} maxLength={200} onChange={setActor} style={{ width: 220, maxWidth: '100%' }} />
      <Input aria-label="连接变更操作" placeholder="操作代码" value={action} maxLength={200} onChange={setAction} style={{ width: 260, maxWidth: '100%' }} />
      <Button icon={<IconSearch />} htmlType="submit">查询记录</Button><Button htmlType="button" icon={<IconRefresh />} aria-label="刷新连接变更记录" disabled={loading} onClick={() => setReload((v) => v + 1)} />
    </form>
    <Typography.Text type="secondary">服务器最多返回最近 200 条连接变更记录；当前接口没有分页。这不是付费操作的结算账本。</Typography.Text>
    {error && <Banner type="danger" closeIcon={null} description={error} />}
    {loading ? <Spin /> : !error && <Table rowKey="id" dataSource={records} pagination={false} empty="没有匹配的连接变更记录" scroll={{ x: 720 }} columns={[
      { title: '时间', dataIndex: 'createdAt', width: 180, render: (v: string) => Number.isNaN(Date.parse(v)) ? '--' : new Date(v).toLocaleString() },
      { title: '操作者', dataIndex: 'actor', width: 150 }, { title: '操作', dataIndex: 'action', width: 220 }, { title: '连接 ID', dataIndex: 'resourceId', width: 240 }
    ]} />}
  </div>;
}
